import { useParams, useNavigate } from 'react-router';
import {
  useInstructorCourseDetail,
  useUpdateCourseStatus,
  useDeleteCourse,
} from '@/api/course-builder';
import { LoadingSpinner } from '@/components/shared/loading-spinner';
import { ErrorMessage } from '@/components/shared/error-message';
import { CourseHeader } from './_components/course-header';
import { SectionList } from './_components/section-list';
import { InstructorSection } from './_components/instructor-section';
import { PositionTrainingSection } from './_components/position-training-section';
import { RecurrenceSection } from './_components/recurrence-section';
import type { CourseStatus } from '@/types';

export function InstructorCourseDetailPage() {
  const { id } = useParams<{ id: string }>();
  const courseId = Number(id);
  const navigate = useNavigate();

  const { data: course, isLoading, error } = useInstructorCourseDetail(courseId);
  const statusMutation = useUpdateCourseStatus();
  const deleteMutation = useDeleteCourse();

  if (isLoading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message={error.message} />;
  if (!course) return <ErrorMessage message="Capacitación no encontrada" />;

  const isDraft = course.status === 'draft';
  const sections = course.sections ?? [];

  const handleStatusChange = (newStatus: CourseStatus) => {
    statusMutation.mutate({ id: courseId, status: newStatus });
  };

  const handleDelete = () => {
    deleteMutation.mutate(courseId, {
      onSuccess: () => navigate('/instructor/courses'),
    });
  };

  return (
    <div>
      <CourseHeader
        course={course}
        onStatusChange={handleStatusChange}
        onDelete={handleDelete}
        statusPending={statusMutation.isPending}
        deletePending={deleteMutation.isPending}
        statusError={statusMutation.error}
      />

      <SectionList sections={sections} isDraft={isDraft} courseId={courseId} />

      {/* Instructors */}
      <div className="mt-8">
        <InstructorSection
          courseId={courseId}
          instructors={course.course_instructors ?? []}
          isDraft={isDraft}
        />
      </div>

      {/* Position-Training matrix */}
      <div className="mt-8">
        <PositionTrainingSection courseId={courseId} />
      </div>

      {/* Recurrence config */}
      <div className="mt-8">
        <RecurrenceSection courseId={courseId} />
      </div>
    </div>
  );
}
